<script>
export let iconClass = 'fas fa-bicycle';
export let iconClass2 = 'fas fa-bicycle';
export let title = '-';
export let figure = '22';
export let decimalPlaces = 0;

</script>

<section class="sectionx hero bg-secondary has-text-white is-fullheight">
  <div class="hero-body">
    <div class="container">
      <h2 class="ioreveal animate__animated" data-anicss="animate__fadeInDown"><i class="{iconClass}"></i> {title}</h2>
      <!-- <h1 class="has-text-primary figure">22% /h1> -->
      <h1 class="has-text-primary figure ioreveal animate__animated animate__delay-2s"  style="animation-delay: 0.3s;" data-anicss="animate__fadeIn">
        <span
          data-countup="{figure}"
          data-countup-decplaces="{decimalPlaces}">0
        </span>%
        <i class="{iconClass2}"></i>
      </h1>
      <div
        class="ioreveal animate__animated animate__delay-2s"
        style="animation-delay: 0.5s;"
        data-anicss="animate__fadeInUp">
		    <slot name="description"></slot>
      </div>

      <!-- <p>{description}</p> -->
    </div>
  </div>
</section>
